import React, {  useRef, useEffect } from "react";
import i from 'images/buttons/i.svg'
import 'styles/main/Tooltip.sass';
import { useSelector } from 'react-redux';




export default function Tooltip(props) {
  const tooltip = useSelector((state) => state.tooltip);

  useEffect(() => { 
    console.log('render Tooltip')
  });

  if (!tooltip) return null

  return (
    <div className="infoTt" style={{"top": tooltip.y+"px", "left": tooltip.x+10+"px"}}>
      <div className='headerTt'>{tooltip.title}</div>
      <div className='contentTt' dangerouslySetInnerHTML={{__html: tooltip.body}}></div>
    </div>
  )
}
